/*
 * @Author: 李文 
 * @Date: 2020-10-31 10:08:33 
 * @Last Modified by: 李文
 * 其他稿件预览
 */
import React from 'react'
import { getManuscriptById } from '../../../actions/resourceList'
import { Spin } from 'antd'
import './index.scss'


class PreviewPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            itemData: {},
            loading: false,
        }
    }

    componentDidMount() {
        this.setState({
            loading: true
        }, () => {
            getManuscriptById({ id: this.props.match.params.id, type: this.props.match.params.type }, (res) => {
                if (res.state) {
                    let itemData=res.data;
                    itemData.content= itemData.content.replace(/<embed[^>]*vsbmp4video=[^>]*>/ig, function(videoEmbed){
                        return videoEmbed.replace("<embed", "<video controls").replace(/(.*)src=\"[^\"]*\"(.*)vsburl=\"([^\"]*)\"(.*)/, "$1 $2 src=\"$3\" $4</video>").replace(/ src=/," old_src=").replace(/ ue_src=\"([^\"]*)/," src=\"$1?.mp4");
                    }).replace(/<embed[^>]*vsbmp3audio=[^>]*>/ig, function(audioEmbed){
                        return audioEmbed.replace("<embed", "<audio controls").replace(/(.*)src=\"[^\"]*\"(.*)vsb_data=\"([^\"]*)\"(.*)/, "$1 $2 src=\"$3\"  controls=\"controls\" $4</audio>");
                    });
                    this.setState({
                        itemData: itemData,
                        loading: false
                    })
                }
            })
        })
    }

  dealContent = (data) => {
      let reg = new RegExp("/system/resource/",'g');
        let video_res = /<embed[^>]*vsbmp4video="true"[^>]*>/g;
        if(video_res.test(data)){
            data.replace(video_res, function (match) {
                return match.replace("<embed","<video controls").replace(/ src=/," old_src=").replace(/ ue_src=\"([^\"]*)/," src=\"$1?.mp4");
            })
        }

        let audio_res = /<embed[^>]*vsbmp3audio="true"[^>]*>/g;
        if(audio_res.test(data)){
             data.replace(audio_res, function(embedHTML){
                let realSrc = embedHTML.replace(/.*vsb_data="([^"]*)".*/, "$1");
                embedHTML = embedHTML.replace(/(src=")[^"]*"/, "$1"+realSrc+"?v="+new Date().getTime()+"\"");
                return embedHTML.replace("<embed","<audio controls");
            });
        }
      return data.replace(reg,'/cm-sites/system/resource/')
  }

    render() {
        const { itemData, loading } = this.state;
        return (
            <div className="preview-page">
                {
                    loading ? <div className="loading"><Spin /></div> :
                        <div className="wrap">

                            <div className="title_1" title={itemData.title}>{itemData.title}</div>
                            <div className="title_2" title={itemData.summary}>{itemData.summary ? `——${itemData.summary}` : ''}</div>
                            {
                                itemData.content && 
                                <div className="content" dangerouslySetInnerHTML={{ __html: this.dealContent(itemData.content) }}></div>

                            }
                            

                        </div>
                }
            </div>
        )
    }
}

export default PreviewPage